import { TAction, TActionRequest } from "../../base/types/redux";
import {
  GetEkycOptionsResponse,
  CreateEkycRequest,
  ApiStateType,
  GetStockCodeOptionsResponse
} from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

export const getEkycOptions = (params: any): TActionRequest<any> => {
  return {
    type: ACTION_TYPES.GET_EKYC_OPTIONS,
    params,
  };
};

export const setEkycOptions = (response: GetEkycOptionsResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_EKYC_OPTIONS,
    response,
  };
};

export const postCreateEkyc = (params: CreateEkycRequest): TActionRequest<CreateEkycRequest> => {
  return {
    type: ACTION_TYPES.POST_CREATE_EKYC,
    params,
  };
};

export const setCreateEkycState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_CREATE_EKYC_STATE,
    response,
  };
};

export const getStockCodeOptions = (params: any): TActionRequest<any> => {
  return {
    type: ACTION_TYPES.GET_STOCK_CODE_OPTIONS,
    params,
  };
};

export const setStockCodeOptions = (response: GetStockCodeOptionsResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_STOCK_CODE_OPTIONS,
    response,
  };
};